import type {HubSpotFormSliceDefault} from 'prismicio-types'
import {EVENTS, track} from 'src/common/helpers'
import {useCreateHubspotForm} from 'src/common/hooks'

/**
 * Props for `HubSpotForm`.
 */
type HubSpotFormDefaultProps = {
  slice: HubSpotFormSliceDefault
  pageUid: string
  componentIndex: number
}

/**
 * Component for "HubSpotForm" Slices.
 */
export const HubSpotFormDefault = ({slice, componentIndex, pageUid}: HubSpotFormDefaultProps) => {
  useCreateHubspotForm({
    region: 'eu1',
    portalId: slice.primary.portal_id!,
    formId: slice.primary.form_id!,
    target: '#hubspot-form-wrapper',
    onFormSubmit: () => {
      track({
        location: `component-${componentIndex}-hubspot-form`,
        dataType: slice.primary.form_type!,
        event: EVENTS.FORM_SUBMIT,
        mktgId: 'form-submission-button',
        pageName: pageUid,
      })
    },
  })

  return <div className={slice.primary.container_css_classes + ' md:!pt-[112px]' || ''} id="hubspot-form-wrapper" />
}
